<!-- eslint-disable vue/no-v-html -->
<template>
  <v-card
    outlined
    class="mini-post-card-wrapper"
    :style="`border-bottom-color: ${getChannelColorNameAndIcon(post.channel).color};`"
  >
    <div class="mini-post-card">
      <div class="mini-post-card__social-icon">
        <a
          :href="post.post_url"
          target="_blank"
        >
          <component
            :is="getChannelComponent(post.primaryChannel || post.primary_channel || post.channel)"
            :channel="post.primaryChannel || post.primary_channel || post.channel"
          />
        </a>
      </div>
      <div class="mini-post-card__user-pic">
        <v-avatar size="30">
          <img
            :src="post.user_image_url || avatarPlaceholder"
            @error="useWarroomAvatar"
          >
        </v-avatar>
      </div>
      <div class="mini-post-card__user-name">
        <div class="text-truncate">
          {{ post.name }}
        </div>
      </div>
      <div
        v-tooltip="post.posted_at"
        class="mini-post-card__user-date text-truncate"
      >
        <small>{{ post.posted_at }}</small>
      </div>
      <v-row
        no-gutters
        justify="center"
        align="center"
        align-content="center"
        class="mini-post-card__user-image"
      >
        <v-col
          v-if="hasImageUrl"
          class="pa-3"
        >
          <v-img
            :src="post.image_url"
            max-width="100%"
          />
        </v-col>
      </v-row>
      <div class="mini-post-card__user-text pa-3">
        <span v-html="post.text" />
      </div>
      <div class="mini-post-card__metrics pb-2">
        <PostIconAndTextMetric
          v-for="(metric, index) in metrics"
          :key="index"
          :metric="metric"
          :value="post[metric] || 0"
        />
      </div>
    </div>
  </v-card>
</template>

<script>
import channelsModel from '@/mixins/channel-model';
import { findSocialIcon } from '@/utils/channels';
import PostIconAndTextMetric from '@/components/Post/PostIconAndTextMetric';

export default {
  name: 'MiniPost',
  components: {
    PostIconAndTextMetric,
  },
  mixins: [
    channelsModel,
  ],
  props: {
    post: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      avatarPlaceholder: 'https://warroom.stilingue.com.br/img/profiles/avatar.png',
      metrics: ['likes', 'shares', 'comments', 'videoplays', 'followers'],
    };
  },
  computed: {
    hasImageUrl() {
      return Boolean(this.post.image_url);
    },
  },
  methods: {
    getChannelComponent(channel) {
      return findSocialIcon(channel);
    },
    useWarroomAvatar(event) {
      event.target.src = this.avatarPlaceholder;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~@stilingue/st-styles/colors.scss';

  .mini-post-card-wrapper {
    border-color: rgba(map-get($colors, white), 0.05);
    border-bottom-width: 3px;
    border-bottom-style: solid;
  }

  .mini-post-card {
    display: grid;
    grid-template-columns: 70px 45px auto 100px;
    grid-template-rows: 64px;
    grid-template-areas: "social-icon pic name date" "img img img img" "text text text text" "metrics metrics metrics metrics";

    &__social-icon {
      grid-area: social-icon;
      justify-self: center;
      align-self: center;
    }

    &__user-pic {
      grid-area: pic;
      justify-self: end;
      align-self: center;
      margin: 15px;
    }

    &__user-name {
      grid-area: name;
      display: grid;
      align-self: center;
    }

    &__user-date {
      display: grid;
      align-self: center;
      grid-area: date;
      font-size: 12px;
    }

    &__user-text {
      grid-area: text;
      font-size: 12px;
      max-height: 70px;
      margin-bottom: 8px;
      overflow: hidden;
    }

    &__user-image {
      grid-area: img;
      overflow: hidden;
      height: 100%;
      width: 100%;
      max-height: 400px;
    }

    &__metrics {
      grid-area: metrics;
      display: flex;
      justify-content: space-around;
      margin: 8px 0;
    }
  }
</style>
